import { render, staticRenderFns } from "./SideCartMobile.vue?vue&type=template&id=3f72a364&scoped=true&"
import script from "./SideCartMobile.vue?vue&type=script&lang=js&"
export * from "./SideCartMobile.vue?vue&type=script&lang=js&"
import style0 from "./SideCartMobile.vue?vue&type=style&index=0&id=3f72a364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f72a364",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f72a364')) {
      api.createRecord('3f72a364', component.options)
    } else {
      api.reload('3f72a364', component.options)
    }
    module.hot.accept("./SideCartMobile.vue?vue&type=template&id=3f72a364&scoped=true&", function () {
      api.rerender('3f72a364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Step2Mobile/SideCartMobile.vue"
export default component.exports